<template>
    <div class="widget-table-columns-alignment-field">
        <div class="w-full mb-3">
            <RedesignFormLabel
                :label="String($t('widget.tableColumnsAlignment'))"
                class="mb-2"
            />
            <RedesignRadioGroup
                v-model="displayedAlignment"
                class="radio-groups alignment-buttons-group"
            >
                <RedesignRadioButton
                    label="left"
                    name="left"
                >
                    <redesign-base-icon
                        name="AlignLeft"
                        :size="24"
                    />
                </RedesignRadioButton>
                <RedesignRadioButton
                    label="center"
                    name="center"
                >
                    <redesign-base-icon
                        name="AlignCenter"
                        :size="24"
                    />
                </RedesignRadioButton>
                <RedesignRadioButton
                    label="right"
                    name="right"
                >
                    <redesign-base-icon
                        name="AlignRight"
                        :size="24"
                    />
                </RedesignRadioButton>
            </RedesignRadioGroup>
        </div>
    </div>
</template>

<script setup lang="ts">
import RedesignRadioGroup from '@/components/RedesignBaseComponents/Inputs/RedesignRadioGroup.vue'
import RedesignFormLabel from '@/components/RedesignBaseComponents/Form/RedesignFormLabel.vue'
import RedesignRadioButton from '@/components/RedesignBaseComponents/Inputs/RedesignRadioButton.vue'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'
import { computed } from 'vue'
import { isRTL } from '@/composables/useDirection'
import type { TableAlignmentType } from '@/types/alignment'
import { TableAlignment } from '@/types/alignment'
import { invertAlignmentForRTL } from '@/helpers/alignmentUtils'

const props = withDefaults(defineProps<{
    alignment?: TableAlignmentType
    hasColumnSpecificAlignment?: boolean
}>(), {
    hasColumnSpecificAlignment: false
})

const emit = defineEmits<{
    (e: 'update:alignment', value: TableAlignmentType): void
}>()

const displayedAlignment = computed<TableAlignmentType | undefined>({
    get () {
        if (props.hasColumnSpecificAlignment) {
            return undefined
        }
        
        if (props.alignment === undefined) {
            return isRTL.value ? TableAlignment.right : TableAlignment.left
        }
        
        return invertAlignmentForRTL(props.alignment)
    },
    set (val: TableAlignmentType | undefined) {
        if (val === undefined) return
        emit('update:alignment', invertAlignmentForRTL(val))
    }
})
</script>

<style lang="scss" scoped>
.alignment-buttons-group {
    direction: ltr !important;
    
    :deep(.el-radio-button.base-radio-button) {
        &:first-child .el-radio-button__inner {
            border-radius: 4px 0 0 4px !important;
        }
        &:last-child .el-radio-button__inner {
            border-radius: 0 4px 4px 0 !important;
        }
    }
}
</style>